import React from 'react';

const TextComponent = ({ text="" , limit=24}) => {
  if (text.length > limit) {
    // Truncate the text to 7 characters and add three dots
    const truncatedText = text.substring(0, limit) + '...';
    return <span title={text}>{truncatedText}</span>;
  }

  return <span title={text}>{text}</span>;
};

export default TextComponent;
